import React from 'react';
import useNewsAndInsights from './hooks/useNewsAndInsights';

function NewsAndInsights(props) {
  const { ...config } = useNewsAndInsights(props);  
  // eslint-disable-next-line react/prop-types
  const dataLabels = JSON.parse(props.labels);
 
  const tabs = (
    <div className="tabbed-content__tabs">
      <div className="container">
        <button
          className="tabbed-content__tab"
          aria-selected={config.showSeeAll ? 'true' : 'false'}
          onClick={() => {
            config.handleToggleTabs('seeAll');
          }}
        >
          {(dataLabels && dataLabels.seeAll) ? dataLabels.seeAll : 'See All'}
        </button>
        <button
          className="tabbed-content__tab"
          aria-selected={config.showNews ? 'true' : 'false'}
          onClick={() => {
            config.handleToggleTabs('news');
          }}
        >
          {(dataLabels && dataLabels.news) ? dataLabels.news : 'News'}
        </button>
        <button
          className="tabbed-content__tab"
          aria-selected={config.showWebinars ? 'true' : 'false'}
          onClick={() => {
            config.handleToggleTabs('webinars');
          }}
        >
          {(dataLabels && dataLabels.webinars) ? dataLabels.webinars : 'Webinars'}
        </button>
        <button
          className="tabbed-content__tab"
          aria-selected={config.showBlogs ? 'true' : 'false'}
          onClick={() => {
            config.handleToggleTabs('blogs');
          }}
        >
          {(dataLabels && dataLabels.blogs) ? dataLabels.blogs : 'Blogs'}
        </button>
        <button
          className="tabbed-content__tab"
          aria-selected={config.showResources ? 'true' : 'false'}
          onClick={() => {
            config.handleToggleTabs('resources');
          }}
        >
          {(dataLabels && dataLabels.resources) ? dataLabels.resources : 'Resources'}
        </button>
      </div>
    </div>
  );

  const mobileSelectRender = (
    <div 
      className="news-and-insights__facets-wrapper"
      onClick={() => {
        config.handleSelectClick(config.mobileFilterExpanded);
      }}
    >
      <div className="news-and-insights__narrow-results-heading">
        <span>
          {config.mobileActiveTabText}
        </span>
        <div className="news-and-insights__filters-actions">
            <button
              aria-label="News and Insights Narrow Results"
              onClick={() => {
                config.handleSelectClick(config.mobileFilterExpanded);
              }}
              aria-expanded={config.mobileFilterExpanded}
              aria-controls="news-and-insights__facets-content"
              className="news-and-insights__narrow-results-toggle"
            >
              <span>
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  className="news-and-insights__facet-chevron-down-icon"
                  role="presentation"
                >
                  <use xlinkHref="#icon-chevron-up"></use>
                </svg>
              </span>
            </button>
          </div>
        </div>
 
        
      <div className="news-and-insights__facets-content">

        {(config.mobileActiveTabId !== 'seeAll') ? (
          <button
            className='news-and-insights__facet-option'
            onClick={() => {
              config.handleSelectClick(config.mobileFilterExpanded);
              config.handleToggleTabs('seeAll');
            }}
          >
            {(dataLabels && dataLabels.seeAll) ? dataLabels.seeAll : 'See All'}
          </button>
        ) : null}

        {(config.mobileActiveTabId !== 'news') ? (
          <button className='news-and-insights__facet-option'
          onClick={() => {
            config.handleSelectClick(config.mobileFilterExpanded);
            config.handleToggleTabs('news');
          }}
          >
            {(dataLabels && dataLabels.news) ? dataLabels.news : 'News'}
          </button>
        ) : null}

        {(config.mobileActiveTabId !== 'webinars') ? (
          <button className='news-and-insights__facet-option'
          onClick={() => {
            config.handleSelectClick(config.mobileFilterExpanded);
            config.handleToggleTabs('webinars');
          }}
          >
            {(dataLabels && dataLabels.webinars) ? dataLabels.webinars : 'Webinars'}
          </button>
        ) : null}

        {(config.mobileActiveTabId !== 'blogs') ? (
          <button className='news-and-insights__facet-option'
          onClick={() => {
            config.handleSelectClick(config.mobileFilterExpanded);
            config.handleToggleTabs('blogs');
          }}
          >
            {(dataLabels && dataLabels.blogs) ? dataLabels.blogs : 'Blogs'}
          </button>
        ) : null}

        {(config.mobileActiveTabId !== 'resources') ? (
          <button className='news-and-insights__facet-option'
          onClick={() => {
            config.handleSelectClick(config.mobileFilterExpanded);
            config.handleToggleTabs('resources');
          }}
          >
            {(dataLabels && dataLabels.resources) ? dataLabels.resources : 'Resources'}
          </button>
        ) : null}

      </div>
    </div>
  );

  const renderSwiperWithGroupData = groupData => {
    config.createSwiper();
    const cleanGroupData = groupData.filter(item => item !== undefined);

    return (
      <div className="swiper-container content-cards__container">
        <div className="swiper-wrapper">
          {cleanGroupData.map((item, index) => (
            <div className="swiper-slide" key={index}>
              <a href={item.link} className="content-card">
                <div className="content-card__image">
                  <picture>
                    <source media="(max-width: 767px)" srcSet={item.image} />
                    <source media="(max-width: 1024px)" srcSet={item.image} />
                    <img
                      src={item.image}
                      width=""
                      height=""
                      alt="Image Description"
                      loading="lazy"
                    />
                  </picture>
                </div>
                <div className="content-card__wrapper">
                  <div className="head-subhead-group">
                    <h3>
                      <span className="eyebrow">{item.type}</span>
                      <span className="content-card__heading-text">{item.title}</span>
                    </h3>
                  </div>
                  <div className="content-card__copy rtf">
                    {item.description}
                  </div>
                  <div className="content-card__cta">
                    <span className="content-card__cta-label">Learn More</span>
                    <svg viewBox="0 0 8 12" role="presentation">
                      <use xlinkHref="#chevron-right"></use>
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
        <div className="news-and-insights__pagination">
          <button className="swiper-button-prev" aria-label="Previous">
            <svg viewBox="0 0 10 14" role="presentation">
              <use xlinkHref="#chevron-left"></use>
            </svg>
          </button>
          <div className="swiper-pagination"></div>
          <button className="swiper-button-next" aria-label="Next">
            <svg viewBox="0 0 10 14" role="presentation">
              <use xlinkHref="#chevron-right"></use>
            </svg>
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className='news-and-insights__container container'>
        <div className="news-and-insights__wrapper">
          {(dataLabels && dataLabels.hideModuleTitle === "False" && dataLabels.moduleTitle) ? <h2>{dataLabels.moduleTitle}</h2> : ''}
          {(dataLabels && dataLabels.hideModuleTitle === "False" && !dataLabels.moduleTitle) ? <h2>What’s hapenning at Amwell</h2> : ''}
          {mobileSelectRender}
          <div className="news-and-insights__body">
            {tabs}
            {renderSwiperWithGroupData(config.activeDataGroup)}
          </div>
        </div>
      </div>
    </>
  );
}

NewsAndInsights.defaultProps = {};

NewsAndInsights.propTypes = {};

export default NewsAndInsights;
